import React, { useState, useEffect } from 'react';
import BetaIcon, { IconSizes } from '../Icons/Icon';

const StarInput = ({
  register,
  defaultValue = 0,
  inputName = 'score',
  onChange,
}) => {
  const [score, setScore] = useState(defaultValue);
  const [hoveredStars, setHoveredStars] = useState(0);

  useEffect(() => {
    if (onChange) {
      onChange(score);
    }
  }, [score]);

  return (
    <>
      <div
        style={{ WebkitTapHighlightColor: 'transparent' }}
        className="d-flex gap-s pointer pt-base pb-3xs"
        onMouseLeave={() => setHoveredStars(0)}
      >
        {new Array(5).fill(null).map((_, i) => {
          return (
            <div
              key={`start-${i}`}
              onMouseOver={() => setHoveredStars(i + 1)}
              onClick={() => setScore(i + 1)}
            >
              <BetaIcon
                key={i}
                name={
                  hoveredStars >= i + 1 || score >= i + 1
                    ? 'valutationStar1'
                    : 'valutationStar0'
                }
                size={IconSizes[24]}
              />
            </div>
          );
        })}
      </div>
      <input
        type="number"
        style={{ display: 'none' }}
        name={inputName}
        value={score}
        ref={(e) => {
          register(e, {
            required: true,
            validate: (value) => /^[1-5]$/.test(value),
          });
        }}
        onChange={() => null}
        data-gtm-item="model-order-review-form"
        data-gtm-detail="score"
      />
    </>
  );
};

export { StarInput };
